// extracted by mini-css-extract-plugin
export default {"seg":"nurseTabs_seg__5J3ip","on":"nurseTabs_on__IaSiY"};